import { render, staticRenderFns } from "./OptionOrigin.vue?vue&type=template&id=4e4b7c44&scoped=true&"
import script from "./OptionOrigin.vue?vue&type=script&lang=js&"
export * from "./OptionOrigin.vue?vue&type=script&lang=js&"
import style0 from "./OptionOrigin.vue?vue&type=style&index=0&id=4e4b7c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4b7c44",
  null
  
)

export default component.exports